<script setup lang="ts">
import { onMounted,onBeforeUnmount,ref,reactive } from 'vue'
import CustomEvent from "../../compositions/CustomEvent.vue";
import CustomList from "../../compositions/CustomList.vue";
import config from "../../config.js";
import { successAlert } from "../../plugins/alert";
import qs from 'qs';
import axios from '../../plugins/axios.ts';
import { useOrderStore } from '../../stores/order';
import { useStockStore } from '../../stores/stock';
import { usePharmacyStore } from '../../stores/pharmacy';

const order = useOrderStore();
const stock = useStockStore();
const pharmacy = usePharmacyStore();

const props = defineProps({
    currentPharmacyName:{
      type:String,
      required:true,
    },
    apis:{
      type:Object,
      required:true,
    }
})

const listRef = ref();
const currentPharmacyName = ref(props.currentPharmacyName);
const isListShow = ref(false);
const isChangeLoading = ref(false);

const pharmacyNameClick = () => {
  isListShow.value = !isListShow.value;
}
const pharmacyNameClose = () => {
  isListShow.value = false;
}
const pharmacySelectClick = (pharmacyId) => {
  isListShow.value = false;
  isChangeLoading.value = true;
  let params = new FormData();
  params.append('pharmacy_id', pharmacyId);
  axios(props.apis.user_update_current_pharmacy,{method:"post",data:params})
  .then((response) => {
    //その他の設定を全てリセットする必要があるので一旦画面リロード
    pharmacy.store_reset = 1;
    setTimeout(() => {
      window.location.reload();
    },500);
  })
  .catch((error) => {
    isChangeLoading.value = false;
    currentPharmacyName.value = '変更失敗';
  })
  .then(() => {
  });
}
const pharmacyReset = () => {
  isClosing.value = true;
}

const {element,isClosing,clickOutside} = CustomEvent(pharmacyNameClose)
onBeforeUnmount(() => {
  window.removeEventListener('click', clickOutside);
});
onMounted(() => {
  window.addEventListener('click', clickOutside);
  if (pharmacy.store_reset == 1) {
    //編集中データリセット
    order.reset_data();
    stock.reset_data();
  }
  pharmacy.store_reset = 0;
});
</script>

<style scoped>
</style>
<template>
<div ref="element">
  <button type="button" class="w-24 md:w-auto bg-amber-500 rounded-full focus:ring-4 focus:ring-amber-300" aria-expanded="false" data-dropdown-toggle="dropdown-pharmacy" data-dropdown-placement="bottom" @click="pharmacyNameClick">
    <div v-if="isChangeLoading">
        <img src="../../../public/images/loading.gif" style="margin:auto;padding:5px 40px;">
    </div>
    <span v-else class="block text-white text-xs px-2 py-1 md:py-2 md:text-xl md:px-6">{{ currentPharmacyName }}</span>
  </button>
  <!-- Dropdown menu -->
  <div v-show="isListShow" class="absolute z-50 mb-4 text-base list-none bg-white rounded divide-y divide-gray-100 shadow">
    <custom-list
      ref="listRef"
      :is-searchable="true"
      place-holder="薬局名を入力"
      width="100%"
      :api-url="apis.user_pharmacy_list"
      :reset="pharmacyReset"
    >
    <template v-slot:item="slotProps">
      <div class="w-full" @click="pharmacySelectClick(slotProps.item.id)">
        {{ slotProps.item.pharmacy_name }}
      </div>
    </template>
    </custom-list>
  </div>
</div>
</template>

